// @flow
import React, { Component, Fragment } from "react";

import { StyledTextField } from "imagus-components";
import InfiniteCalendarSelect from "../../../global/components/InfiniteCalendarSelect";
import AddressBlock from "../companies/AddressBlock";

import Grid from "@material-ui/core/Grid";

type ProjectBasicFieldsPropsType = {
  project_name: string,
  expiry_date: Date | null,
  face_count: string,
  camera_count: string,
  address: string,
  suburb: string,
  postcode: string,
  city: string,
  state: string,
  other_state: string,
  country: string,
  notes: string,
  handleTextChange: Function,
  handleSelectChange: Function,
  syncDateChange: Function
};

class ProjectBasicFields extends Component<ProjectBasicFieldsPropsType, *> {
  render(): React$Element<*> {
    return (
      <Fragment>
        <Grid item xs={12} md={6}>
          <StyledTextField
            isRequired={true}
            label="Project Name"
            name="project_name"
            value={this.props.project_name}
            onChange={this.props.handleTextChange}
            inpuType="text"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <InfiniteCalendarSelect
            isRequired={true}
            label="Estimated Close Date"
            name="expiry_date"
            value={this.props.expiry_date}
            syncDateChange={this.props.syncDateChange}
            min_date={new Date()}
            isEndDate
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <StyledTextField
            isRequired={false}
            label="Amount of Faces (if Known)"
            name="face_count"
            value={this.props.face_count}
            onChange={this.props.handleTextChange}
            inpuType="number"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <StyledTextField
            isRequired={false}
            label="Amount of Cameras/ Streams/ Channels (if known)"
            name="camera_count"
            value={this.props.camera_count}
            onChange={this.props.handleTextChange}
            inpuType="number"
          />
        </Grid>
        <AddressBlock
          title="Project Location"
          address={this.props.address}
          suburb={this.props.suburb}
          postcode={this.props.postcode}
          city={this.props.city}
          state={this.props.state}
          other_state={this.props.other_state}
          country={this.props.country}
          handleTextChange={this.props.handleTextChange}
          handleSelectChange={this.props.handleSelectChange}
        />
        <Grid item xs={12}>
          <StyledTextField
            isRequired={false}
            label="Notes"
            name="notes"
            value={this.props.notes}
            onChange={this.props.handleTextChange}
            inpuType="text"
            rows={4}
          />
        </Grid>
      </Fragment>
    );
  }
}

export default ProjectBasicFields;
